export const getLocalStorage = function (key, defaultValue) {
    try {
        return localStorage.getItem(key)
    } catch (error) {
      return error
    }
  }
  
  export const setLocalStorage = function (key, value) {
    localStorage.setItem(key,value)
  }
  export const removeLocalStorage=function (key,value){
    localStorage.removeItem(key)
  }
  